import type { TypeTableColumn } from '@thefarmersfront/kitchen';

type TypeProductNameRow = {
  productName: string;
};

const getDeliveryAgencyProductNamesColumnDefs = () => {
  const columnDefs: TypeTableColumn<TypeProductNameRow>[] = [
    {
      accessorKey: 'productName',
      header: '상품명',
      minSize: 252,
      meta: { flex: true, overflow: 'wrap' },
    },
  ];

  return { columnDefs };
};

export default getDeliveryAgencyProductNamesColumnDefs;
